import Routes from "@/common/router/Routes";
import { customerRouter } from "@/context/customer/router/CustomerRouter";

export default class CustomerRoutes extends Routes {
  constructor() {
    super({
      label: "Klient",
      router: customerRouter,
      lazyPage: () => import("@/context/customer/page/CustomerPage.vue"),
      lazyCreate: () => import("@/context/customer/container/CustomerFormContainer.vue"),
      lazyUpdate: () => import("@/context/customer/container/CustomerFormContainer.vue"),
      lazyList: () => import("@/context/customer/container/CustomerListContainer.vue"),
      lazyShow: () => import("@/context/customer/container/CustomerShowContainer.vue")
    });
  }
}

export const customerRoutesConfig = new CustomerRoutes().routeConfig;
